import { render, staticRenderFns } from "./CMChangePassword.vue?vue&type=template&id=39bb36e5&scoped=true&"
import script from "./CMChangePassword.vue?vue&type=script&lang=js&"
export * from "./CMChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./CMChangePassword.vue?vue&type=style&index=0&id=39bb36e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb36e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bb36e5')) {
      api.createRecord('39bb36e5', component.options)
    } else {
      api.reload('39bb36e5', component.options)
    }
    module.hot.accept("./CMChangePassword.vue?vue&type=template&id=39bb36e5&scoped=true&", function () {
      api.rerender('39bb36e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/CMChangePassword.vue"
export default component.exports